<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
      small
      class="ma-0"
    >
      <v-icon color="primary" small>edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Geschäftsführer bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Unternehmenstitel"
                  v-model="localCeo.company"
                  required
                  :rules="[v => !!v || 'Dies ist ein Pflichtfeld']"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                  :items="genders"
                  v-model="localCeo.gender"
                  label="Anrede"
                  single-line
                  :disabled="loading"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Titel"
                  v-model="localCeo.title"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="localCeo.forename"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname"
                  v-model="localCeo.surname"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Email"
                  required
                  v-model="localCeo.email"
                  :rules="emailRules"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-switch
                  :label="`Per ${localCeo.formal ? 'Sie' : 'Du'}`"
                  v-model="localCeo.formal"
                  :disabled="loading"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="update()" :loading="loading">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'DlgCeoUpdate',
    props: ['ceo'],
    data() {
      return {
        dialog: false,
        localCeo: {},
        loading: false,
        valid: true,
        emailRules: [
          (v) => !!v || 'E-mail ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
        ],
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    methods: {
      ...mapActions({
        updateCeo: 'admin/ceos/update',
        readCeos: 'admin/ceos/read',
      }),
      update() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.updateCeo(this.localCeo).then((success) => {
            this.loading = false;
            if (success) {
              this.readCeos();
              this.localCeo = {};
              this.dialog = false;
            }
          });
        }
      },
    },
    watch: {
      dialog() {
        this.localCeo = JSON.parse(JSON.stringify(this.ceo));
      },
    },
  };
</script>

<style scoped>

</style>
